import React, { Component } from 'react';
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {CCActions, CCLayout} from '../../cc-imports'
import {Home} from './../../screens/Home'
import {Leagues} from './../../screens/Leagues'
import {Transactions} from '../../modals/TransactionsModal'
import Media from 'react-media'

import './../../styles/css/routes/Root/root.css';
import CCBackLayout from "../../layout/CCBackLayout/CCBackLayout";


class Root extends Component {

    constructor(props) {
        super(props);
        this.state = {

        };
        this._signUpGoogle=this._signUpGoogle.bind(this)
    }

    _signUpGoogle(){
        //this.props.actions.signIn(this.props.actions.getUserByEmail);
    }

    render(){
        return (
            <CCLayout>
                <div className={'flex-container home-res'}>
                    <div className={'flex-container row root-container'}>
                        <div className={'home-root-container'}>
                            <Home/>
                        </div>
                        <Media query={"(min-device-width : 737px)"}>
                            <div className={'leagues-root-container'}>
                                <Leagues/>
                            </div>
                        </Media>
                    </div>
                </div>
            </CCLayout>
        );
    }
}


export default connect(state=>({
    //user: state.user.user,
}), (dispatch)=>({
    actions: bindActionCreators({...CCActions}, dispatch),
    dispatch: dispatch
}))(Root);


// WEBPACK FOOTER //
// ./src/app/routes/Root/Root.js